var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"rq_page_main_wrp"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-auto ml-md-auto"},[_c('pp-left-sidebar')],1),_c('div',{staticClass:"col-md pl-md-0"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }